/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAction } from './ControlAction';
import {
    ControlActionFromJSON,
    ControlActionFromJSONTyped,
    ControlActionToJSON,
} from './ControlAction';
import type { ControlResult } from './ControlResult';
import {
    ControlResultFromJSON,
    ControlResultFromJSONTyped,
    ControlResultToJSON,
} from './ControlResult';
import type { ControlType } from './ControlType';
import {
    ControlTypeFromJSON,
    ControlTypeFromJSONTyped,
    ControlTypeToJSON,
} from './ControlType';

/**
 * 
 * @export
 * @interface ControlActionContainWithUser
 */
export interface ControlActionContainWithUser {
    /**
     * 
     * @type {ControlAction}
     * @memberof ControlActionContainWithUser
     */
    action: ControlAction;
    /**
     * 
     * @type {string}
     * @memberof ControlActionContainWithUser
     */
    caseId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlActionContainWithUser
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlActionContainWithUser
     */
    detectionId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlActionContainWithUser
     */
    directoryUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlActionContainWithUser
     */
    endpointId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlActionContainWithUser
     */
    fileId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlActionContainWithUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlActionContainWithUser
     */
    integrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlActionContainWithUser
     */
    integrationPlatform?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlActionContainWithUser
     */
    integrationResponse?: { [key: string]: any; };
    /**
     * 
     * @type {ControlResult}
     * @memberof ControlActionContainWithUser
     */
    result?: ControlResult;
    /**
     * 
     * @type {string}
     * @memberof ControlActionContainWithUser
     */
    subAction?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlActionContainWithUser
     */
    teamId: string;
    /**
     * 
     * @type {ControlType}
     * @memberof ControlActionContainWithUser
     */
    type: ControlType;
    /**
     * 
     * @type {string}
     * @memberof ControlActionContainWithUser
     */
    userId?: string;
}

/**
 * Check if a given object implements the ControlActionContainWithUser interface.
 */
export function instanceOfControlActionContainWithUser(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "teamId" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function ControlActionContainWithUserFromJSON(json: any): ControlActionContainWithUser {
    return ControlActionContainWithUserFromJSONTyped(json, false);
}

export function ControlActionContainWithUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlActionContainWithUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action': ControlActionFromJSON(json['action']),
        'caseId': !exists(json, 'caseId') ? undefined : json['caseId'],
        'createdAt': json['createdAt'],
        'detectionId': !exists(json, 'detectionId') ? undefined : json['detectionId'],
        'directoryUserId': !exists(json, 'directoryUserId') ? undefined : json['directoryUserId'],
        'endpointId': !exists(json, 'endpointId') ? undefined : json['endpointId'],
        'fileId': !exists(json, 'fileId') ? undefined : json['fileId'],
        'id': json['id'],
        'integrationId': !exists(json, 'integrationId') ? undefined : json['integrationId'],
        'integrationPlatform': !exists(json, 'integrationPlatform') ? undefined : json['integrationPlatform'],
        'integrationResponse': !exists(json, 'integrationResponse') ? undefined : json['integrationResponse'],
        'result': !exists(json, 'result') ? undefined : ControlResultFromJSON(json['result']),
        'subAction': !exists(json, 'subAction') ? undefined : json['subAction'],
        'teamId': json['teamId'],
        'type': ControlTypeFromJSON(json['type']),
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
    };
}

export function ControlActionContainWithUserToJSON(value?: ControlActionContainWithUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action': ControlActionToJSON(value.action),
        'caseId': value.caseId,
        'createdAt': value.createdAt,
        'detectionId': value.detectionId,
        'directoryUserId': value.directoryUserId,
        'endpointId': value.endpointId,
        'fileId': value.fileId,
        'id': value.id,
        'integrationId': value.integrationId,
        'integrationPlatform': value.integrationPlatform,
        'integrationResponse': value.integrationResponse,
        'result': ControlResultToJSON(value.result),
        'subAction': value.subAction,
        'teamId': value.teamId,
        'type': ControlTypeToJSON(value.type),
        'userId': value.userId,
    };
}

